<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1200px"
      unit="合并工单"
      edit-title
      id-key="UserId"
      :data="data"
      form-label-width="100px"
      :form-rules="rules"
      @opened="onOpened"
      @close-saved="$emit('close-saved')"
      
    >
      <template slot="form">
        <el-row class="border">
          <el-row :gutter="15">
            <el-col :span="10">
              <el-form-item label="新工单号" required>
                <span
                  style="display: inline-block; width: 180px"
                  v-if="Mode == 0"
                  class="detail-span"
                  >{{ data.WorkDocNo }}</span
                >
                <el-input
                  style="width: 180px"
                  v-else
                  v-model="data.WorkDocNo"
                  placeholder="请输入新工单号"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="新单据日期" required>
                <el-date-picker
                  v-model="data.DocDate"
                  type="date"
                  placeholder="请选择单据日期"
                  value-format="yyyy-MM-dd"
                  @change="(v) => getPreviewNo(currentSerialType, v)"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
      </template>

      <div class="flex">
        <div>
          <span class="span-top-text">待合并工单</span>
        </div>
        <el-button type="primary" @click="openWorkList">添加</el-button>
      </div>

      <el-table
        class="table_bottom table-line tb-c-head"
        border
        ref="list"
        :data="tableData"
      >
        <el-table-column
          prop="DocDate"
          label="老单据日期"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="WorkDocNo"
          label="老工单号"
          min-width="120"
        ></el-table-column> 
        <el-table-column
          prop="ProductName"
          label="存货名称"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="MouldName"
          label="模具名称"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="PropertyName"
          label="属性"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="ColorName"
          label="颜色"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="Quantity"
          label="数量"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="StageName"
          label="加工阶段"
          min-width="120"
        ></el-table-column> 
        <el-table-column
          prop="ProgrammeName"
          label="工艺方案"
          min-width="120"
        ></el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="80">
          <template slot-scope="{ $index }">
            <el-button
              v-if="$permission.canWrite()"
              type="text"
              @click="del($index)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <div v-for="(item, index) in child" :key="index">
        <div class="flex">
          <div>{{ item.name }}子件</div>
        </div>
        <el-table
          class="table_bottom table-line tb-c-head"
          border
          :data="item.child"
        >
          <el-table-column
            prop="ProductNo"
            label="子件编码"
            min-width="120"
          ></el-table-column>
          <el-table-column
            prop="ProductName"
            label="子件名称"
            min-width="120"
          ></el-table-column>
          <el-table-column
            prop="PropertyName"
            label="子件属性"
            min-width="120"
          ></el-table-column>
          <el-table-column
            prop="ColorName"
            label="子件颜色"
            min-width="120"
          ></el-table-column>
          <el-table-column
            prop="Quantity"
            label="子件数量"
            min-width="120"
          ></el-table-column>
        </el-table>
      </div>
      <template slot="footer">
        <el-button type="primary" @click="save">保存</el-button>
        <el-button @click.stop="close">关 闭</el-button>
      </template>
    </common-dialog>
    <work-list ref="workList" @saved="saved"></work-list>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import workList from "../common/workList";

// import iForm from '@/data/sys/user/IForm.json'

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    workList,
  },
  data() {
    return {
      tableData: [],
      child: [],
      data: {
        WorkDocNo: "",
        DocDate: "",
        OldWorkDocIdArray: [],
      },
      Mode: 0,
      rules: {
        Code: [{ required: true, message: "请输入加工单号" }],
        DocTime: [{ required: true, message: "请选择时间" }],
      },
      api: require('@/api/production/workDoc').default,
      code_api: require("@/api/sy/serialCode").default,
      currentSerialType: "",
      // trendData: iForm.Data,
    };
  },

  methods: {
    onOpened(){
      this.tableData = [];
      this.child = [];
      this.currentSerialType = "";
    }, 
    del(index) {
      this.tableData.splice(index, 1);
      this.child.splice(index, 1);
    },
    openWorkList() {
      this.$refs.workList.open().then((that) => {
        that.$refs.list.getData();
      });
    },
    save(){
      this.api.mergeWorkDoc(this.data).then(res => {
        if(res.Code === 0){
          this.$message({type: 'success', message: res.Msg});
          this.$emit('saved')
          this.data = {
            WorkDocNo: "",
            DocDate: "",
            OldWorkDocIdArray: [],
          }
          this.tableData = [];
          this.child = [];
          this.close(true)
        }else{
          this.$message({type: 'warning', message: res.Msg})
        }
      })
    },
    getPreviewNo(serialType, dataTime = ""){
      if(this.currentSerialType){
        this.code_api.previewNo(serialType, dataTime).then((res) => {
          if (res.Code == 0) {
            this.Mode = res.Data.Mode;
            this.data.WorkDocNo = res.Data.PreviewNo;
          } else {
            this.$message.warning("获取合并工单编号失败");
          }
        });
      }
      
    },
    saved(list) {
      this.child = [];
      this.tableData = [];
      list.forEach((item) => {
        this.child.push({
          name: item.ProductName,
          child: item.WorkDocMaterialsList,
        });

        let {WorkDocMaterialsList, ...rest} = item;
        this.tableData.push(rest);
      });

      this.data.OldWorkDocIdArray = this.tableData.map(item => {
        return item.WorkDocId;
      })

      let serialType = '';
      let Stage = list[0].Stage;
      switch(Stage){
        case 0:
          serialType = '注塑工单'
          this.currentSerialType = serialType;
          break;
        case 1:
          serialType = '特殊工单'
          this.currentSerialType = serialType;
          break;
        case 2:
          serialType = '配件工单'
          this.currentSerialType = serialType;
          break;
        case 3:
          serialType = '装配工单'
          this.currentSerialType = serialType;
          break;
        case 4:
          serialType = '组合工单'
          this.currentSerialType = serialType;
          break;
      }

      
      if(!this.data.DocDate){
        this.data.DocDate = this.$commonJs.getToday();
      }
      this.getPreviewNo(serialType, this.data.DocDate)
    },
  },
};
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
  margin: 18px;
  justify-content: space-between;
  align-items: center;
}
</style>
